import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  learnerRecordsTabHeader: {
    id: 'learner.record.tab.header',
    defaultMessage: 'Learner Records',
  },
  earnedStatus: {
    id: 'earned.status',
    defaultMessage: 'Earned',
  },
  notEarnedStatus: {
    id: 'not.earned.status',
    defaultMessage: 'Not Earned',
  },
  partiallyCompletedStatus: {
    id: 'partially.completed.status',
    defaultMessage: 'Partially Completed',
  },
  recordTableLastUpdated: {
    id: 'record.table.last.updated',
    defaultMessage: 'Last updated',
  },
  copyPublicRecordLinkButton: {
    id: 'copy.public.record.link',
    defaultMessage: 'Copy public record link',
  },
  recordTableHeaderCourseName: {
    id: 'record.table.header.course.name',
    defaultMessage: 'Course Name',
  },
  recordTableHeaderSchool: {
    id: 'record.table.header.school',
    defaultMessage: 'School',
  },
  recordTableHeaderCourseId: {
    id: 'record.table.header.course.id',
    defaultMessage: 'Course ID',
  },
  recordTableHeaderHighestGrade: {
    id: 'record.table.header.highest.grade',
    defaultMessage: 'Highest grade earned',
  },
  recordTableHeaderLetterGrade: {
    id: 'record.table.header.letter.grade',
    defaultMessage: 'Letter Grade',
  },
  recordTableHeaderVerifiedAttempts: {
    id: 'record.table.header.verified.attempts',
    defaultMessage: 'Verified Attempts',
  },
  recordTableHeaderDateEarned: {
    id: 'record.table.header.date.earned',
    defaultMessage: 'Date Earned',
  },
  recordTableHeaderStatus: {
    id: 'record.table.header.status',
    defaultMessage: 'Status',
  },
  noPublicLink: {
    id: 'no.public.record.link',
    defaultMessage: 'There is no public instance for this record. Learners must create a public link on their own.',
  },
  noRecordsFound: {
    id: 'no.records.found',
    defaultMessage: 'No results found for username',
  },
});

export default messages;
